import React, { createContext, PropsWithChildren } from 'react';
import { TsFixMeType } from '../..';

export const StorageContext = createContext<StorageDriver | null>(null);

export type StorageDriver = {
  getItem: (key: string) => Promise<TsFixMeType>;
  setItem: (key: string, value: TsFixMeType) => Promise<TsFixMeType>;
  removeItem: (key: string) => Promise<TsFixMeType>;
};

interface StorageProviderProps {
  storageDriver: StorageDriver;
}

const StorageProvider: React.FC<PropsWithChildren<StorageProviderProps>> = ({ storageDriver, children }) => {
  return <StorageContext.Provider value={storageDriver}>{children}</StorageContext.Provider>;
};

export default StorageProvider;
